import { render, staticRenderFns } from "./StageTemplate.vue?vue&type=template&id=ae443150&"
import script from "./StageTemplate.vue?vue&type=script&lang=js&"
export * from "./StageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports